module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"expand_review":"리뷰 더보기","collapse_review":"리뷰 접기"}}')
  delete Component.options._Ctor
}
